/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconArrowBadgeLeftFilled = createReactComponent(
  "arrow-badge-left-filled",
  "IconArrowBadgeLeftFilled",
  [
    [
      "path",
      {
        d: "M17 6h-6a1 1 0 0 0 -.78 .375l-4 5a1 1 0 0 0 0 1.25l4 5a1 1 0 0 0 .78 .375h6l.112 -.006a1 1 0 0 0 .669 -1.619l-3.501 -4.375l3.5 -4.375a1 1 0 0 0 -.78 -1.625z",
        fill: "currentColor",
        key: "svg-0",
        strokeWidth: "0"
      }
    ]
  ]
);

export { IconArrowBadgeLeftFilled as default };
//# sourceMappingURL=IconArrowBadgeLeftFilled.js.map
